
export const CANCEL_ORDER= 'CANCEL_ORDER'
export const CANCEL_ORDER_SUCCESS= 'CANCEL_ORDER_SUCCESS'
export const CANCEL_ORDER_ERROR='CANCEL_ORDER_ERROR'


export const CancelOrder= (data) => ({
    type: CANCEL_ORDER,
    payload: data
});